import { render, staticRenderFns } from "./ReportContent.vue?vue&type=template&id=6347aa96&scoped=true&"
import script from "./ReportContent.vue?vue&type=script&lang=js&"
export * from "./ReportContent.vue?vue&type=script&lang=js&"
import style0 from "./ReportContent.vue?vue&type=style&index=0&id=6347aa96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347aa96",
  null
  
)

export default component.exports
import {QBtn,QScrollArea,QList,QItem} from 'quasar'
component.options.components = Object.assign({QBtn,QScrollArea,QList,QItem}, component.options.components || {})
